const modelSlide = (() => {

  const pageModelroom = (document.getElementById("pageModelroom") != null);
  if (pageModelroom) {

    // スライド
    const jsSecSlide2 = document.getElementById('jsSecSlide2');
    // const modelSwiper1 = jsSecSlide2.querySelector('.js-swiper-1');
    // const modelThumbnail1 = jsSecSlide2.querySelector('.js-thumbnail-1');

    // const sliderThumbnail1 = new Swiper(modelThumbnail1, {
    //   slidesPerView: "auto",
    //   allowTouchMove: false,
    // });

    // const swiper1 = new Swiper(modelSwiper1, {
    //   slidesPerView: 1,
    //   effect: 'fade',
    //   speed: 1500,
    //   autoplay: {
    //     delay: 4000,
    //     disableOnInteraction: false,
    //   },
    //   thumbs: {
    //     swiper: sliderThumbnail1,
    //   },
    // });
    // swiper1.autoplay.stop();


    const modelSwiper2 = jsSecSlide2.querySelector('.js-swiper-2');
    const modelThumbnail2 = jsSecSlide2.querySelector('.js-thumbnail-2');

    const sliderThumbnail2 = new Swiper(modelThumbnail2, {
      slidesPerView: "auto",
      allowTouchMove: false,
    });

    const swiper2 = new Swiper(modelSwiper2, {
      slidesPerView: 1,
      effect: 'fade',
      speed: 1500,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      thumbs: {
        swiper: sliderThumbnail2,
      },
    });
    // swiper2.autoplay.stop();



    // タブ切り替え
    // let btn = jsSecSlide2.querySelectorAll('.js-tab-btn');
    // let cntnt = jsSecSlide2.querySelectorAll('.js-tab-cntnt');

    // for (let i = 0; i < btn.length; i++) {
    //   btn[i].addEventListener("click", () => {

    //     // 押されたiとjが同じだったらactとらない
    //     for (let j = 0; j < btn.length; j++) {
    //       if (!(j == i)) {
    //         btn[j].classList.remove("act");
    //         cntnt[j].classList.remove("act");
    //       }
    //     }

    //     btn[i].classList.add('act');
    //     cntnt[i].classList.add('act');

    //     swiper1.autoplay.stop();
    //     swiper2.autoplay.stop();
    //     if (i == 0) {
    //       swiper1.autoplay.start();
    //     }
    //     if (i == 1) {
    //       swiper2.autoplay.start();
    //     }
    //   });
    // }

    // swiper1.autoplay.start();


  }

})();
export default modelSlide;